import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatCalendar, MatTableDataSource } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { Stop, Stops } from '../../../@core/models/live-route';
import { SectorService } from '../../../@core/services/sector.service';
import { NotificationService } from '../../../@core/utils/notification.service';
import { DashboardBase } from '../../../pages/auth/dashboard/dashboard.base';

@Component({
  selector: 'ngx-transfert-date-dialog',
  templateUrl: './transfert-date-dialog.component.html',
  styleUrls: ['./transfert-date-dialog.component.scss']
})
export class TransfertDateDialogComponent extends DashboardBase {
  selectedSector: any;
  @ViewChild('calendar', {static: false}) calendar: MatCalendar<any>;
  selectedDate: any;


  ngOnInit(

  ): void {
  }

  transfert() {
    if(this.selectedDate){
      if (this.isCurrentTimeAfterDeadline()) {
       if(this.translate.currentLang == "fr"){
        this.toastrService.error("Les transferts sont désactivés à cette heure.", "Non autorisé")   
       }else{
        this.toastrService.error("Transfers are disabled at this time.", "Not allowed");
       } 
        return;
      }
      let date = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      this.apiProvider
        .BatchTransferStopDate(
          date,
          this._stopService.RouteDate,
          this._stopService.currentStopsValue.Route_ID,
          1,
          this.authenticationService.currentUserValue.UserID,
          this._stopService.selectedStops
        )
        .subscribe((response) => {
          this._stopService.currentStopsSubject = new BehaviorSubject<Stops>(
            response.RouteStops
          );
          this._stopService.currentStops = this._stopService.currentStopsSubject.asObservable();
          this._stopService.dataSource = new MatTableDataSource<Stop>(
            this._stopService.currentStopsValue.StopsList
          );
        });
    }
    //this.Batchmove(this._stopService.selectedStops, this.selectedSector, 1, 2);
  }

  private isCurrentTimeAfterDeadline(): boolean {
    const now = new Date();  
    const deadline = new Date();
    deadline.setHours(20, 55, 0, 0); // aujourd’hui à 20h55 
    const routeDate = new Date(this._sectorService.RouteDate);
    routeDate.setHours(0, 0, 0, 0); // ignore l'heure
    const today = new Date();
    today.setHours(0, 0, 0, 0); // ignore l'heure
  
    if (routeDate <= today) {
      const afterDeadline = now > deadline;
      return afterDeadline;
    }
  
    return false;
  }
  
}
